import PropTypes from 'prop-types'
import useMedia from 'use-media'

import {
  Box,
  Columns,
  Col,
  Icon,
  Heading,
  Image,
  Label,
  Link,
  mediaQueries,
  Text,
} from '@redriverpress/system'

import ImagePlaceholder from './ImagePlaceholder'
import HitWrapper from './HitWrapper'
import {
  flashcardPropShape,
  flashcardCategoryPropShape,
} from '../../constants/propShapes'

import { getVideoLink } from '../../utils/hitLinks'
import {
  resultImageSize,
  descriptionCharLimitDefault,
  descriptionCharLimitMd,
} from '../../constants/ui'

export default function GenericVideoHit({ hit }) {
  const {
    image_url: imageUrl,
    slug,
    title,
    subtitle,
    description,
    category,
  } = hit

  const isMd = useMedia(mediaQueries.md)

  const descriptionCharLimit = isMd
    ? descriptionCharLimitMd
    : descriptionCharLimitDefault

  const { title: categoryTitle } = category
  return (
    <Link reset href={getVideoLink({ slug })}>
      <HitWrapper px={3} py={[3, null, 4]} mb={[3, null, 4]}>
        <Columns>
          <Col width={[1, null, 1 / 4]}>
            <Box mb={[3, null, 0]} position='relative'>
              {imageUrl ? (
                <>
                  <Box position='absolute' size='100%'>
                    <Box
                      size={resultImageSize}
                      borderRadius='circular'
                      bg='rgba(35,31,32,0.5)'
                      display='flex'
                      justifyContent='center'
                      alignItems='center'
                      mx={[undefined, null, 'auto']}
                    >
                      <Icon icon='play' weight='solid' color='white' />
                    </Box>
                  </Box>
                  <Image
                    alt=''
                    src={imageUrl}
                    size={resultImageSize}
                    display='block'
                    mx={[undefined, null, 'auto']}
                    borderRadius='circular'
                    style={{ objectFit: 'cover' }}
                  />
                </>
              ) : (
                <ImagePlaceholder icon='video' />
              )}
            </Box>
          </Col>
          <Col width={[1, null, 3 / 4]}>
            <Box mb={3}>
              <Label compact type='materialType'>
                <Icon icon='video' pr={2} />
                Video
              </Label>
            </Box>
            <Heading as='h4' mb={1}>
              {title}
            </Heading>
            <Text fontWeight={600}>{categoryTitle}</Text>
            {subtitle && (
              <Box display='flex' alignItems='baseline' my={3}>
                <Icon width='1rem' pr={2} flexShrink={0} icon='lightbulb' />
                <Text fontSize={0}>{subtitle}</Text>
              </Box>
            )}
            {description && (
              <Text fontSize={0} measure>
                {description.length > descriptionCharLimit
                  ? `${description.substring(0, descriptionCharLimit)}…`
                  : description}
              </Text>
            )}
          </Col>
        </Columns>
      </HitWrapper>
    </Link>
  )
}

GenericVideoHit.propTypes = {
  hit: PropTypes.oneOfType([flashcardPropShape, flashcardCategoryPropShape])
    .isRequired,
}
